module.exports = __webpack_public_path__ + "static/posicionamiento3-cdc7bd73340ba84fa30c08bd712cfab9.jpg";